(timesactScriptNew = async function (t) {
  let e = document.createElement("style");
  (e.id = "TimesactCSS"),
    (e.innerHTML = `.timesact-badge-ribbon span::before {
                           
                            content: "";
                            position: absolute; left: 0px; top: 100%;
                            z-index: -1;
                            border-left: 3px solid #888888;
                            border-right: 3px solid transparent;
                            border-bottom: 3px solid transparent;
                            border-top: 3px solid #888888;
                        }
                        .timesact-badge-ribbon span::after {
                            content: "";
                            position: absolute; right: 0px; top: 100%;
                            z-index: -1;
                            border-left: 3px solid transparent;
                            border-right: 3px solid #888888;
                            border-bottom: 3px solid transparent;
                            border-top: 3px solid #888888;
                        }
                        .md-modal {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            width: 40%;
                            height: auto;
                            z-index: 999999999999;
                            visibility: hidden;
                            transform: translateX(-50%) translateY(-50%);
                        }
                        .md-content {
                            background: #fff;
                            position: relative;
                            border-radius: 10px;
                            margin: 0 auto;
                        }
                        .md-show {
                            visibility: visible;
                        }
                        .md-show ~ .md-overlay {
                            opacity: 1;
                            visibility: visible;
                            display: block;
                        }
                        .popup-container {
                            min-height: 100%;
                            display: none;
                        }
                        .md-overlay {
                            position: fixed;
                            width: 100%;
                            height: 100%;
                            visibility: hidden;
                            top: 0;
                            left: 0;
                            z-index: 1000;
                            opacity: 0;
                            background: #c9c9c9c2;
                            -webkit-transition: all 0.3s;
                            -moz-transition: all 0.3s;
                            transition: all 0.3s;
                        }
                        .md-body {
                            text-align: center;
                            padding-top: 10%;
                            padding-bottom: 10%;
                            font-family: "Roboto";
                        }
                        p.message {
                              padding: 20px;
                        }
                        .md-close {
                            background: #f70427;
                            border: none;
                            color: white;
                            padding: 10px;
                            border-radius: 4px;
                            cursor: pointer;
                        }
                        @media screen and (max-width: 32em) {
                            .md-modal { width: 80%; }
                        }
                        .timesact_bis_popup_overlay {
                            position: fixed;
                            top: 0;
                            left: 0;
                            z-index: 1040;
                            visibility: hidden;
                            width: 100vw;
                            height: 100vh;
                            background-color: #000;
                            opacity: .5;
                            display: block !important;
                        }

                        .timesact_bis_dialog {
                            display: inline-table;
                            position: fixed;
                            top: 0;
                            left: 0;
                            z-index: 1050;
                            visibility: hidden;
                            width: 100%;
                            height: 100%;
                            overflow-x: hidden;
                            overflow-y: auto;
                            outline: 0;
                        }
                        
                        .timesact_bis_popup_overlay_show,
                        .timesact_bis_dialog_show {
                            visibility: visible;
                        }
                        
                        .timesact_bis_popup {
                            z-index: 1000000;
                            background: #fff;
                            color: #000;
                            margin: auto;
                            pointer-events: none;
                            max-width: 460px;
                            width: 96%;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            position: fixed;
                            border-radius: 10px;
                            font-size: 14px;
                            /*add dynamic value*/
                        }

                        .timesact_bis_popup_content {
                            pointer-events: auto;
                            position: relative
                        }

                        .timesact_bis_popup_body {
                            padding: 20px;
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            border-radius: .3rem
                        }

                        .timesact_bis_close_button {
                            padding: 5px;
                            background: 0 0;
                            font-size: 1.4rem;
                            font-weight: 700;
                            line-height: 1;
                            opacity: 1;
                            cursor: pointer;
                            outline: 0;
                            border-radius: 0;
                            position: absolute;
                            top: 0;
                            right: 0;
                            border: 0
                        }

                        .timesact_bis_close_span {
                            display: inline-block;
                            height: 20px;
                            width: 20px;
                            color: #000;
                            margin-top: 0;
                        }

                        .timesact_bis_heading {
                            margin-bottom: 0;
                            color: #000;
                            /*dynamic value*/
                            margin-top: 0;
                            font-size: calc(2 * 1em);
                            /*dynamic value*/
                            font-weight: 700
                        }

                        .timesact_bis_desc {
                            margin-bottom: 0;
                            color: #000;
                            /*dynamic value*/
                            font-size: 14px;
                            /*dynamic value*/
                        }

                        .timesact_bis_line {
                            margin: 10px 0
                        }

                        .timesact_bis_form_field {
                            margin-top: 10px
                        }

                        .timesact_bis_input {
                            padding: 8px 15px;
                            border: 1px solid #949494;
                            background-color: #fff;
                            color: #000;
                            max-width: 100%;
                            line-height: 1.2;
                            width: 100%;
                            outline: 0;
                            border-radius: 10px;
                            /*dynamic value*/
                        }

                        .timesact_bis_submit_button {
                            width: 100%;
                            outline: 0;
                            border: 0;
                            padding: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #000;
                            /*dynamic value*/
                            color: #fff;
                            /*dynamic value*/
                            border-radius: 10px;
                            /*dynamic value*/
                            font-size: 14px;
                            cursor: pointer;
                        }

                        .timesact_bis_submit_button--disabled {
                            background: #ddd
                        }

                        .timesact_bis_loading_icon {
                            width: 15px !important;
                            height: 15px !important;
                            margin-right: 5px !important;
                        }

                        .timesact_bis_loading_icon:after {
                            content: " ";
                            display: block;
                            width: 15px !important;
                            height: 15px !important;
                            border-radius: 50%;
                            border: 2px solid #fff;
                            border-color: #fff transparent #fff transparent;
                            animation: timesact-bis-loading 1.2s linear infinite
                        }

                        @keyframes timesact-bis-loading {
                            0% {
                                transform: rotate(0)
                            }

                            100% {
                                transform: rotate(360deg)
                            }
                        }

                        .timesact_bis_note {
                            color: black;
                            font-size: 80%;
                            margin-bottom: 0
                        }
                        
                        .timesact_bis_response {
                            margin-bottom: 0;
                        }

                        .timesact_bis_message_success {
                            width: 100%;
							text-align: center;
							font-weight: 600;
                            display: none;
                            color: #28a745;
                        }

                        .timesact_bis_message_error {
                            width: 100%;
							text-align: center;
							font-weight: 600;
                            display: none;
                            color: red;
                        }

                        .timesact_powered_by {
                            margin-top: 15px;
                            left: 0;
                            right: 0;
                            text-align: center;
                        }

                        .timesact_powered_by a {
                          text-decoration: none;
                          color: #000 !important;
                          font-weight: 700;
                        }
                        
                        .timesact_bis_field_empty {
                          border: 1px solid red;
                        }
                        
                        .timesact_bis_message_show {
                            display: block !important;
                        }
                        
                        .timesact-button:after {
                            content: none
                        }

                        .timesact-button:before {
                            content: none
                        }
                        .timesact_bis_subscribe {
                          font-size: 80%;
                        }

                        .timesact_sub #newsletter {
                            height: 14px !important;
                            width: 14px !important;
                        }
                        .timesact_sub {
                            display: none;
                        }

                        #timesact_widget{
                            width: 100%;
                            text-align: left;
                            margin-top: 17px;
                            clear: both;
                            max-width: 400px;
                            
                        }
                        #timesact_widget .timesact_widget_wrapper {
                            border: 1.5px solid #cccccc;
                            // box-shadow: 0 0 0 1px #c4cdd5;
                            border-radius: 5px;
                            margin-bottom: 5px;
                            margin-top: 10px;
                        }
                        
                        #timesact_widget .timesact_option {
                            display: flex;
                            position: relative;
                            padding: 16px 16px;
                            flex-direction: column;
                        }
                        
                        #timesact_widget .timesact_option:first-child {
                            border-bottom: inherit;
                        }
                        #timesact_widget .timesact_option:first-child:last-child {
                            border-bottom: none;
                        }

                        #timesact_widget .timesact_radio_label {
                            display: flex !important;
                            align-items: center;
                            margin: 0;
                            padding: 0;
                            background: none;
                        }
                        
                        .timesact_circle {
                            position: relative;
                        }
                        
                        .timesact_option input[type=radio]:focus + label .timesact_circle:before {
                            height: 24px;
                            width: 24px;
                            border: 2px solid #3a3a3a;
                            border-radius: 50%;
                            flex-shrink: 0;
                            content: '';
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                        
                        [name="selling_plan"] {
                          position: absolute;
                          opacity: 0;
                        }

                        #timesact_widget .timesact_circle {
                            display: flex;
                            height: 18px;
                            width: 18px;
                            border: 2px solid #3a3a3a;
                            border-radius: 50%;
                            margin-right: 10px;
                            justify-content: center;
                            align-items: center;
                            flex-shrink: 0;
                            
                          }
                      
                        #timesact_widget .timesact_option input[type=radio]:checked + label .timesact_circle .timesact_dot {
                            height: 10px;
                            width: 10px;
                            background-color: #3a3a3a;
                            border-radius: 50%;
                            flex-shrink: 0;
                            
                          }
                          `),
    document.getElementsByTagName("head")[0].appendChild(e),
    document
      .getElementsByTagName("body")[0]
      .insertAdjacentHTML(
        "afterbegin",
        '<div class="md-modal" id="mixed-modal"><div class="md-content"><div class="md-body"></div></div></div><div class="popup-container"><div class="column"><button class="md-trigger md-setperspective" data-modal="mixed-modal"></button></div></div><div class="md-overlay"></div>'
      );
  let i = `<div class="timesact_bis_popup_overlay"></div>
        <div aria-modal="true" aria-hidden="true" tabindex="-1" role="dialog" class="timesact_bis_dialog">
            <div class="timesact_bis_popup">
                <div class="timesact_bis_popup_content">
                    <div class="timesact_bis_popup_body">
                        <button type="button" data-dismiss="modal" aria-label="Close"
                            class="timesact_bis_close_button">
                            <span aria-hidden="true" class="timesact_bis_close_span">x</span>
                        </button>
                        <h3 class="timesact_bis_heading"></h3>
                        <p class="timesact_bis_desc"></p>
                        <p class="timesact_bis_response">
                            <span class="timesact_bis_message_success"></span>
                            <span class="timesact_bis_message_error"></span>
                             
                        </p>
                        <hr class="timesact_bis_line">
                        <div id="subscriptionForm">
                            <div class="timesact_bis_form_field">
                                <input id="timesact_bis_email" class="timesact_bis_input " type="email"
                                placeholder="eg. username@example.com" name="email" value="">
                            </div>
                            <div class="timesact_bis_form_field">
                                <button type="button" class="timesact_bis_submit_button ">
                                    <span class="timesact_bis_loading_icon"></span>
                                </button>
                            </div>
                            <div class="timesact_bis_form_field">
                                <p class="timesact_bis_note"></p>
                            </div>
                            <div class="timesact_bis_form_field timesact_sub">
                                <input type="checkbox" id="newsletter" name="newsletter" checked />
                                <label class="timesact_bis_subscribe" for="newsletter"></label>
                            </div>
                        </div>
                        <div class="timesact_powered_by">
                            <a href="https://timesact.com" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8 24l2.674-9h-9.674l16-15-2.674 9h8.674l-15 15zm-1.586-11h6.912l-1.326 4 5.739-6h-6.065l1.304-4-6.564 6z"></path></svg>
                                <span>by Timesact</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`,
    s = `<div class="timesact_widget" id="timesact_widget">
            <div class="timesact_widget_wrapper">
                <div class="timesact_option">
                    <div class="timesact_radio_wrapper">
                        <input checked type="radio" id="timesact_selling_plan_label" name="selling_plan" value="" tabindex="2">
                        <label for="timesact_selling_plan_label" class="timesact_radio_label">
                            <span class="timesact_circle"><span class="timesact_dot"></span></span>
                            <span class="timesact_text"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        `;
  document.getElementsByTagName("body")[0].insertAdjacentHTML("afterbegin", i);
  let a = document.querySelector("#timesact_bis_email");
  document.querySelector("#newsletter");
  let o = {
    isOpen: !1,
    queue:
      JSON.parse(window.sessionStorage.getItem("modal-queue") || null) || [],
  };
  class r {
    add(e, i, s, a) {
      if ("RIBBON" === i) {
        t(e).remove(`.timesact-badge-common-${a}`),
          t(e).remove(`.timesact-badge-ribbon-${a}`),
          t(e).append(
            `<div class='timesact-badge-ribbon timesact-badge-ribbon-${a}'><span class='timesact-badge-ribbon-span-${a}'><p>` +
              s +
              "</p></span></div>"
          );
        return;
      }
      "ROUNDED" === i &&
        (t(e).remove(`.timesact-badge-common-${a}`),
        t(e).remove(`.timesact-badge-ribbon-${a}`),
        t(e).append(
          `<div class='timesact-badge-common-${a}'><span class='timesact-badge-rounded-span-${a}'>` +
            s +
            "</span></div>"
        )),
        "RECTANGLE" === i &&
          (t(e).remove(`.timesact-badge-common-${a}`),
          t(e).remove(`.timesact-badge-ribbon-${a}`),
          t(e).append(
            `<div class='timesact-badge-common-${a}'><span class='timesact-badge-rectangle-span-${a}'>` +
              s +
              "</span></div>"
          )),
        "SQUARE" === i &&
          (t(e).remove(`.timesact-badge-common-${a}`),
          t(e).remove(`.timesact-badge-ribbon-${a}`),
          t(e).append(
            `<div class='timesact-badge-common-${a}'><span class='timesact-badge-square-span-${a}'>` +
              s +
              "</span></div>"
          )),
        "CIRCLE" === i &&
          (t(e).remove(`.timesact-badge-common-${a}`),
          t(e).remove(`.timesact-badge-ribbon-${a}`),
          t(e).append(
            `<div class='timesact-badge-common-${a}'><span class='timesact-badge-circle-span-${a}'>` +
              s +
              "</span></div>"
          ));
    }
    getPositions(t, e, i, s) {
      return { top: t && s, bottom: !t && s, left: !e && i, right: e && i };
    }
    getPositionsRibbon(t, e) {
      return { top: t ? "19px" : "35px", right: e ? "-20px" : "-5px" };
    }
    getTransformRibbon(t, e) {
      let i = 45;
      return (
        t && !e ? (i -= 90) : t || e ? !t && e && (i -= 270) : (i -= 180),
        { transform: `rotate(${i}deg)`, "-webkit-transform": `rotate(${i}deg)` }
      );
    }
    getTransformRibbonText(t) {
      return t
        ? {}
        : {
            transform: "rotate(180deg)",
            "-webkit-transform": "rotate(180deg)",
          };
    }
    applyStyles(e, i) {
      let s = e.top || void 0 === e.top,
        a = e.right || void 0 === e.right;
      t(".timesact-badge").css({ position: "relative" }),
        t(`.timesact-badge-ribbon-${i}`).css({
          position: "absolute",
          ...this.getPositions(s, a, "-5px", "-5px"),
          width: "75px",
          height: "75px",
          "text-align": "right",
          "z-index": "1",
          overflow: "hidden",
        }),
        t(`.timesact-badge-ribbon-${i} span`).css({
          position: "absolute",
          ...this.getPositionsRibbon(s, a),
          display: "block",
          width: "100px",
          "font-size": `${e.fontSize}px`,
          "font-weight": "bold",
          color: e.fontColor,
          "text-transform": "uppercase",
          "text-align": "center",
          "line-height": "20px",
          "white-space": "nowrap",
          ...this.getTransformRibbon(s, a),
        }),
        t(`.timesact-badge-ribbon-${i} span p`).css({
          margin: 0,
          ...this.getTransformRibbonText(s),
          "font-size": `${e.fontSize}px`,
          color: e.fontColor,
        }),
        t(`.timesact-badge-ribbon-span-${i}`).css({
          "background-color": e.backgroundColor,
          "box-shadow": "0 3px 10px -5px rgba(0, 0, 0, 1)",
        }),
        t(`.timesact-badge-rounded-span-${i}`).css({
          border: "1px solid transparent",
          "border-radius": "4rem",
          display: "inline-block",
          "letter-spacing": ".1rem",
          "line-height": "1",
          padding: "0.6rem 1.3rem",
          "text-align": "center",
          "background-color": e.backgroundColor,
          "border-color": e.backgroundColor,
          "font-size": `${e.fontSize}px`,
          color: e.fontColor,
          "font-weight": "bold",
          "word-break": "break-word",
        }),
        t(`.timesact-badge-rectangle-span-${i}`).css({
          display: "inline-block",
          "min-width": "60px",
          padding: "0.6rem 1.3rem",
          "letter-spacing": ".1rem",
          "line-height": "1",
          "text-align": "center",
          "font-size": `${e.fontSize}px`,
          color: e.fontColor,
          "font-weight": "bold",
          "word-break": "break-word",
          "background-color": e.backgroundColor,
          "border-color": e.backgroundColor,
          border: "1px solid transparent",
        }),
        t(`.timesact-badge-square-span-${i}`).css({
          display: "flex",
          "align-items": "center",
          "justify-content": "center",
          "min-height": "60px",
          "min-width": "60px",
          width: `${e.width}px`,
          height: `${e.width}px`,
          "letter-spacing": ".1rem",
          "line-height": "1",
          "text-align": "center",
          "font-size": `${e.fontSize}px`,
          color: e.fontColor,
          "font-weight": "bold",
          "word-break": "break-word",
          "background-color": e.backgroundColor,
          "border-color": e.backgroundColor,
          border: "1px solid transparent",
          overflow: "hidden",
        }),
        t(`.timesact-badge-circle-span-${i}`).css({
          display: "flex",
          "align-items": "center",
          "justify-content": "center",
          "min-height": "60px",
          "min-width": "60px",
          width: `${e.width + 28}px`,
          height: `${e.width + 28}px`,
          padding: "14px",
          "letter-spacing": ".1rem",
          "line-height": "1",
          "text-align": "center",
          "font-size": `${e.fontSize}px`,
          color: e.fontColor,
          "font-weight": "bold",
          "word-break": "break-word",
          "background-color": e.backgroundColor,
          "border-color": e.backgroundColor,
          border: "1px solid transparent",
          "border-radius": "50%",
          overflow: "hidden",
        }),
        t(`.timesact-badge-common-${i}`).css({
          position: "absolute",
          ...this.getPositions(s, a, "10px", "10px"),
          display: "flex",
          "flex-wrap": "wrap",
          "z-index": "1",
        });
    }
  }
  class n {
    static updateStorage() {
      window.sessionStorage.setItem("modal-queue", JSON.stringify(o.queue));
    }
    static pushQueue(t, e) {
      o.queue.find((e) => e.settings.id === t.id) ||
        (o.queue.push({ settings: t, closeCb: e }), this.updateStorage());
    }
    static popQueue() {
      if (o.queue.length <= 0) return;
      let t = o.queue.pop();
      return this.updateStorage(), t;
    }
    static clearQueue() {
      (o.queue = []), this.updateStorage();
    }
    static showFirst() {
      if (o.isOpen) return;
      let t = this.popQueue();
      t && new n().display(t.settings, t.closeCb);
    }
    display(e, i) {
      if (o.isOpen) return n.pushQueue(e, i);
      (o.isOpen = !0),
        t(".md-body").append(
          "<h3>" +
            e.header +
            '</h3><p class="message">' +
            e.body +
            '</p><button class="md-close">' +
            e.button +
            '</button><p><input type="checkbox" id="md-stop" name="md-stop"><label for="md-stop">' +
            e.stop +
            "</label></p>"
        ),
        t("#mixed-modal").addClass("md-show"),
        t(".md-close, .md-overlay").click(function (e) {
          e.stopPropagation(),
            i instanceof Function && i(),
            (o.isOpen = !1),
            t("#mixed-modal").removeClass("md-show"),
            t(".md-body").empty(),
            n.showFirst();
        }),
        t(".md-close").attr(
          "style",
          `
				background: ${e.buttonBackgroundColor}!important;
				color: ${e.buttonFontColor}!important;`
        );
    }
  }
  class l {
    constructor(t, e, i, s) {
      (this.id = t),
        (this.variants = e),
        (this.title = i),
        (this.sellingPlans = s
          ? s
              .filter((t) => "timesact" == t.app_id)
              .reduce((t, e) => t.concat(e.selling_plans), [])
          : []);
    }
    setActiveVariant(t) {
      this.variantId = t;
    }
    setTimesactVariants(t) {
      if (!t || !t.variants) {
        console.log("[ERROR 2002]: Product config is undefined.");
        return;
      }
      this.timesactVariants = t.variants;
    }
    isPOEnabledForVariant() {
      return (
        !!this.timesactVariants[this.variantId] &&
        !!this.timesactVariants[this.variantId].config &&
        ("isPOEnabled" in this.timesactVariants[this.variantId]
          ? this.timesactVariants[this.variantId].isPOEnabled
          : "ACTIVE" === this.timesactVariants[this.variantId].config.status ||
            "NO_STOCK" === this.timesactVariants[this.variantId].config.status)
      );
    }
    isISEnabledForVariant() {
      return (
        !!this.timesactVariants[this.variantId] &&
        "isISEnabled" in this.timesactVariants[this.variantId] &&
        this.timesactVariants[this.variantId].isISEnabled
      );
    }
    isBISEnabledForVariant() {
      return (
        !!this.timesactVariants[this.variantId] &&
        ((window.ta.currentTimesactProductData.variantId = this.variantId),
        (window.ta.currentTimesactProductData.productName =
          this.timesactVariants[this.variantId].displayName),
        this.timesactVariants[this.variantId].isBISEnabled)
      );
    }
    isCSEnabledForVariant() {
      return (
        !!this.timesactVariants[this.variantId] &&
        this.timesactVariants[this.variantId].isCSEnabled
      );
    }
    getVariantSettings(t, e, i) {
      if (!this.timesactVariants[this.variantId].config.settingsTemplate) {
        let s = t[e];
        if (!this.hasCustomSettings()) return s;
        let a = this.timesactVariants[this.variantId].settings;
        return {
          button: { ...s.button, name: a.buttonName || s.button.name },
          message: {
            ...s.message,
            type: a.messageType || s.message.type,
            value: a.messageValue || s.message.value,
          },
          cart: {
            ...s.cart,
            labelText: {
              key: a.cartLabelTextKey || s.cart.labelText.key,
              value: a.cartLabelTextValue || s.cart.labelText.value,
            },
          },
          badge: s.badge,
        };
      }
      return "PO" === i
        ? this.timesactVariants[this.variantId].config.settingsTemplate in t
          ? t[this.timesactVariants[this.variantId].config.settingsTemplate]
          : t[e]
        : "BIS" === i
        ? this.timesactVariants[this.variantId].configBIS.settingsTemplate in t
          ? t[this.timesactVariants[this.variantId].configBIS.settingsTemplate]
          : t[e]
        : "CS" === i
        ? this.timesactVariants[this.variantId].configCS.settingsTemplate in t
          ? t[this.timesactVariants[this.variantId].configCS.settingsTemplate]
          : t[e]
        : "IS" === i &&
          this.timesactVariants[this.variantId].configIS.settingsTemplate in t
        ? t[this.timesactVariants[this.variantId].configIS.settingsTemplate]
        : t[e];
    }
    hasCustomSettings() {
      return (
        !!this.timesactVariants[this.variantId].settings &&
        "CUSTOM" === this.timesactVariants[this.variantId].settings.type
      );
    }
    isVariantOutOfStock() {
      if (!this.timesactVariants[this.variantId]) return !1;
      let t = this.timesactVariants[this.variantId];
      return !(t.quantity > 0) && "DENY" === t.inventoryPolicy;
    }
  }
  class d {
    constructor() {}
    initTimesact() {
      if (void 0 !== window.ta) return;
      let t = localStorage.getItem("products")
          ? JSON.parse(localStorage.getItem("products"))
          : {},
        e = localStorage.getItem("settings")
          ? JSON.parse(localStorage.getItem("settings"))
          : void 0,
        i = this.computeLastProductUpdate(t),
        s = localStorage.getItem("lastSettingsUpdate")
          ? JSON.parse(localStorage.getItem("lastSettingsUpdate"))
          : 0;
      window.ta = {
        products: t,
        settings: e,
        lastProductUpdate: i,
        lastSettingsUpdate: s,
        cart: {
          showMixedCartAlert:
            !sessionStorage.getItem("showCartMixedAlert") ||
            JSON.parse(sessionStorage.getItem("showCartMixedAlert")),
        },
        quickView: {
          selectors: {
            button:
              ".quick-add__submit, .productitem--action-qs, .boost-pfs-quickview-btn, .cc-quick-buy-btn, .button--quick-shop, .sca-qv-button, .quick-view-btn, .bc-quickview-btn-wrapper, .sca-qv-cartbtn, .js-quick-shop-link, .searchit-quick-view-button, .quick-view, .js-quickbuy-button, .quick-product__btn, .product-card-interaction-quickshop, .product-modal, .productitem--action button, a.quickview, .overlay, a.quickview, .has-quick-view .btn .v-b, .shop-now-button, .quick-buy, .quick_shop, a[data-action='show-product'], .trigger-quick-view, .quickview-button, .quick_view, .qview-button, button.btn-addToCart:last, .quick-shop, .fancybox.ajax, .quick-add-button-variants, .product-thumbnail__quickshop-button, .js-quickView-button",
            form: `.product__form:visible,
							#sca-qv-add-item-form:visible,
							.shopify-product-form:visible,
							.bc-modal-wrapper:visible
							#bc-quickview-cart-form:visible,
							.product_form:visible,
							.searchit-quick-view-form-wrapper
							form:visible, .product-form:visible,
							.quick-buy__product-form:visible,
							.product-single__form:visible,
							form[action='/cart/add']:visible,
							#AddToCartForm:visible,
							form.module:visible,
							#add-to-cart-quickview-form:visible`,
            addToCartButton:
              "[type=submit]:visible:first span, .sca-qv-cartbtn:visible, #addToCart:visible, #bc-quickview-cart-btn:visible, .add_to_cart:visible, #searchit-quick-view-add-to-cart:visible, .product-form__cart-submit:visible, .quickbuy__submit:visible, .add-to-cart:visible, .product-submit:visible, .add:visible, .product-form--atc-button:visible, input.action-button.submit:visible, .addto.cart.sliding-cart:visible, #AddToCart:visible, .product-add:visible, .add-to-cart:visible, .product__submit__add:visible, .product-add-to-cart:visible, #add-to-cart:visible, .product-submit.action-button.product-submit, .product-form__add-button:visible, .add-to-cart-btn:visible, .qview-btn-addtocart:visible, button.btn-addToCart:last, .button--add-to-cart:visible",
            variant:
              "#sca-qv-variant-options select.single-option-selector, .bc-quickview-single-option-selector, .searchit-option-selector-wrapper select, .qview-variants select, select:visible, .radio-wrapper fieldset, input[type='radio']",
            quantity: "[name='quantity']",
            quickviewModalContainer:
              ".quick-add-modal, .theme-modal--quickbuy, .quickview-product .product-quickview:visible, .sca-fancybox-wrap:visible, .mfp-container:visible, .bc-modal-wrapper:visible, .quick-shop:visible, .searchit-modal:visible, #colorbox:visible, .modal--quick-shop:visible, .quickshop:visible, .fancybox-wrap:visible, .fancybox-container:visible, .modal-content:visible, .product-quick-view, section.quick-view, #ShopNowContainer, #ProductScreens, .product.preview, .modal__inner__wrapper:visible, .halo-modal-content:visible, #quickView:visible, .quickshop-content:visible, .modal__inner:visible, .quick-view .content:visible, .qview-product:visible",
          },
        },
      };
    }
    computeLastProductUpdate(t) {
      let e = parseInt(new Date().getTime() / 1e3);
      for (let i of Object.values(t)) {
        if (i.lastUpdate && i.lastUpdate < e) {
          e = i.lastUpdate;
          continue;
        }
        i.lastUpdate || (e = 1);
      }
      return e;
    }
    isProductPage() {
      return (
        -1 < window.location.href.indexOf("/products/") ||
        -1 < window.location.href.indexOf("/products_preview?")
      );
    }
    isCollectionPage() {
      return -1 < window.location.href.indexOf("/collections/");
    }
    isSearchPage() {
      return -1 < window.location.href.indexOf("/search?");
    }
    isPagesPage() {
      return -1 < window.location.href.indexOf("/pages/");
    }
    isHomePage() {
      return "/" === document.location.pathname;
    }
    isCartPage() {
      return -1 < window.location.pathname.indexOf("/cart");
    }
    initQuickView(t) {
      (this.shopData = t), this.createQuickViewButtonListener();
    }
    createQuickViewButtonListener() {
      var e = this;
      t(window.ta.quickView.selectors.button).click(function (i) {
        var s;
        let a = e.getProductHandle(i.currentTarget);
        if (!a) return;
        let o = e.getProductPageJsURL(a);
        t.getJSON(o.concat(".js"), function (t) {
          console.log(t),
            (s = new l(t.id, t.variants, t.title, t.selling_plan_groups));
        })
          .done(function () {
            new y(e.shopData, s).run(!0);
          })
          .fail(function () {
            console.log("[Error 1001]: Product could not be fetched.");
          });
      });
    }
    getProductHandle(e) {
      return t(e).data("product-url").split("/").pop();
    }
    getProductPageJsURL(t) {
      return "https://" + window.location.hostname + "/products/" + t;
    }
    sleep(t) {
      return new Promise(function (e) {
        setTimeout(e, t);
      });
    }
    cleanupModal() {
      t(window.ta.quickView.selectors.quickviewModalContainer)
        .find("#preorder-label")
        .remove(),
        t(window.ta.quickView.selectors.quickviewModalContainer)
          .find(".timesact-preorder-description")
          .remove();
    }
  }
  class c {
    extractVariantId(e, i) {
      var s = window.location.search.match(/variant=([0-9]+)/);
      if (null != s) return s[1];
      let a =
        "radio" ===
        t(i)
          .find(
            "select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']"
          )
          .attr("type")
          ? t(i)
              .find("input[name='id']:checked, input[name='id[]']:checked")
              .val()
          : t(i)
              .find(
                "select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']"
              )
              .val();
      return e.some((t) => t.id.toString() === a) ? a : e[0].id;
    }
  }
  class p {
    static createListeners() {
      t(".timesact_bis_input").focusout(function () {
        let e = t(".timesact_bis_input");
        e.val() &&
          e.hasClass("timesact_bis_field_empty") &&
          (e.removeClass("timesact_bis_field_empty"),
          t(".timesact_bis_message_success").removeClass(
            "timesact_bis_message_show"
          ),
          t(".timesact_bis_message_error").removeClass(
            "timesact_bis_message_show"
          ));
      }),
        t(".timesact_bis_close_button").click(p.hidenBisModal),
        t(".timesact_bis_submit_button").click(p.createSubscription);
    }
    static displayBisModal() {
      let {
          defaultSettings: e,
          productId: i,
          productVariants: s,
          variantId: a,
        } = window.ta.currentTimesactProductData,
        o = new l(i, s);
      o.setActiveVariant(a), o.setTimesactVariants({ variants: s });
      let { form: r } = o.getVariantSettings(
        window.ta.settings,
        e.templates.BIS,
        "BIS"
      );
      t("h3.timesact_bis_heading").attr(
        "style",
        `color: ${r.headingFontColor} !important;`
      ),
        t("#subscriptionForm .timesact_bis_submit_button").attr(
          "style",
          `
				background: ${r.buttonBackgroundColor} !important;
				color: ${r.buttonFontColor} !important;
				border-radius: ${r.fieldsBorderRadius}px !important;
				font-size: ${r.fontSize}px !important;`
        ),
        t("#subscriptionForm .timesact_bis_input").attr(
          "style",
          `
				border-radius: ${r.fieldsBorderRadius}px !important;
				font-size: ${r.fontSize}px !important;`
        ),
        t(".timesact_bis_popup").attr(
          "style",
          `border-radius: ${r.popupBorderRadius}px !important;`
        ),
        t(
          ".timesact_bis_desc, .timesact_bis_note, .timesact_bis_subscribe"
        ).attr("style", `color: ${r.textFontColor} !important;`),
        t(".timesact_bis_email").attr(
          "style",
          `border-radius: ${r.fieldsBorderRadius}px !important;`
        ),
        t(".timesact_bis_heading").text(r.heading),
        t(".timesact_bis_desc").text(r.description),
        t(".timesact_bis_submit_button").text(r.buttonName),
        t(".timesact_bis_form_field .timesact_bis_note").text(r.note),
        t(".timesact_bis_form_field .timesact_bis_subscribe").text(
          r.messageNewsletter
        ),
        t(".timesact_bis_message_success").text(r.messageSuccess),
        t(".timesact_bis_message_error").text(r.messageError),
        r.isNewsletterEnabled &&
          t(".timesact_sub").attr("style", "display: inline-flex !important;"),
        t(".timesact_bis_popup_overlay").addClass(
          "timesact_bis_popup_overlay_show"
        ),
        t(".timesact_bis_dialog").addClass("timesact_bis_dialog_show"),
        r.isBrandEnabled || t(".timesact_powered_by").hide();
    }
    static hidenBisModal() {
      t(".timesact_bis_popup_overlay").removeClass(
        "timesact_bis_popup_overlay_show"
      ),
        t(".timesact_bis_dialog").removeClass("timesact_bis_dialog_show"),
        t(".timesact_bis_message_success")
          .removeClass("timesact_bis_message_show")
          .html(""),
        t(".timesact_bis_message_error")
          .removeClass("timesact_bis_message_show")
          .html(""),
        (a.value = "");
    }
    static async createSubscription() {
      let e = t(".timesact_bis_message_success"),
        i = t(".timesact_bis_message_error"),
        s = t(".timesact_bis_input");
      if (!a.value) {
        s.addClass("timesact_bis_field_empty");
        return;
      }
      let o = {
          type: "EMAIL",
          status: "PENDING",
          value: a.value,
          productId: window.ta.currentTimesactProductData.productId,
          variantId: window.ta.currentTimesactProductData.variantId,
          productName: window.ta.currentTimesactProductData.productName,
          isSubNewsletter: t("#newsletter").is(":checked"),
        },
        r = await f.createSubscription(o);
      r &&
        i.removeClass("timesact_bis_message_show") &&
        e.addClass("timesact_bis_message_show") &&
        t("#timesact_bis_email").val(""),
        !r &&
          e.removeClass("timesact_bis_message_show") &&
          i.addClass("timesact_bis_message_show");
    }
  }
  class u {
    constructor(e, i) {
      (this.addToCartButtonSelector = e),
        (this.hasInsideSpan =
          "span" ===
          t(this.addToCartButtonSelector)
            .first()
            .prop("tagName")
            ?.toLowerCase()),
        "timesact-button-po" === i || "timesact-button-is" === i
          ? (this.button = e)
          : ((this.button = t(`<button type="button" class="${i}" />`).attr(
              "style",
              "display: none !important;"
            )),
            this.hasInsideSpan
              ? t(this.addToCartButtonSelector)
                  .first()
                  .parent()
                  .after(this.button)
              : t(this.addToCartButtonSelector).first().after(this.button));
    }
    showPO(e) {
      this.hasInsideSpan
        ? t(this.button).parent().show()
        : t(this.button).show(),
        t(this.button).val(e.button.name),
        t(this.button).text(e.button.name),
        t(this.button).prop("disabled", !1),
        "DEFAULT" !== e.button.type &&
          (this.hasInsideSpan
            ? t(this.button).first().parent().addClass("timesact-button")
            : t(this.button).first().addClass("timesact-button"),
          this.applyStyles(e.button.style, "timesact-button"));
    }
    showBIS(e) {
      t(this.button).text(e.button.name),
        this.applyStyles(e.button.style, "timesact-button-bis"),
        t(this.button).click(p.displayBisModal),
        t(this.button).show(),
        this.hasInsideSpan
          ? t(this.addToCartButtonSelector)
              .first()
              .parent()
              .attr("style", "display: none !important;")
          : t(this.addToCartButtonSelector)
              .first()
              .attr("style", "display: none !important;");
    }
    showCS(e) {
      t(this.button).text(e.button.name),
        this.button.prop("disabled", !0),
        this.applyStyles(e.button.style, "timesact-button-cs"),
        t(this.button).show(),
        this.hasInsideSpan
          ? t(this.addToCartButtonSelector)
              .first()
              .parent()
              .attr("style", "display: none !important;")
          : t(this.addToCartButtonSelector)
              .first()
              .attr("style", "display: none !important;");
    }
    showAddToCart() {
      this.hasInsideSpan
        ? (t(this.addToCartButtonSelector).first().parent().show(),
          t(this.addToCartButtonSelector)
            .first()
            .parent()
            .removeClass("timesact-button"),
          t(this.addToCartButtonSelector).first().parent().removeAttr("style"))
        : (t(this.addToCartButtonSelector).first().show(),
          t(this.addToCartButtonSelector)
            .first()
            .removeClass("timesact-button"),
          t(this.addToCartButtonSelector).first().removeAttr("style")),
        t(this.addToCartButtonSelector).val(this.addToCartText),
        t(this.addToCartButtonSelector).text(this.addToCartText),
        t(this.addToCartButtonSelector).prop("disabled", !1);
    }
    showOutOfStock() {
      this.hasInsideSpan
        ? (t(this.addToCartButtonSelector).first().parent().show(),
          t(this.addToCartButtonSelector)
            .first()
            .parent()
            .removeClass("timesact-button"),
          t(this.addToCartButtonSelector).first().parent().removeAttr("style"))
        : (t(this.addToCartButtonSelector).first().show(),
          t(this.addToCartButtonSelector)
            .first()
            .removeClass("timesact-button"),
          t(this.addToCartButtonSelector).first().removeAttr("style")),
        t(this.addToCartButtonSelector).val(this.soldOutText),
        t(this.addToCartButtonSelector).text(this.soldOutText),
        t(this.addToCartButtonSelector).prop("disabled", !0);
    }
    setAddToCartText(e) {
      this.addToCartText = e || t(this.addToCartButtonSelector).text();
    }
    setSoldOutText(t) {
      this.soldOutText = t;
    }
    hide() {
      t(this.button).hide();
    }
    disable() {
      this.hasInsideSpan
        ? t(this.button).parent().prop("disabled", !0)
        : t(this.button).prop("disabled", !0),
        t(this.addToCartButtonSelector).prop("disabled", !0);
    }
    confirmButtonExists() {
      return t(this.button).closest("body").length > 0;
    }
    identifyButton(t) {
      this.button = t.formSelector.find(t.ids.addToCartButton);
    }
    applyStyles(e, i) {
      if (
        (t(`.${i}`).attr(
          "style",
          `
                width: ${e.width}${
            "PERCENT" === e.widthType ? "%" : "px"
          } !important;
                height: ${e.height}${
            "PERCENT" === e.heightType ? "%" : "px"
          } !important;
                background-color: ${e.backgroundColor} !important;
                border: ${e.borderWidth}px solid ${e.borderColor} !important;
                border-color: ${e.borderColor} !important;
                border-radius: ${e.borderRadius}px !important;
                border-width: ${e.borderWidth}px !important;
                color: ${e.fontColor} !important;
                font-size: ${e.fontSize}px !important;
                font-style: ${e.fontStyle} !important;
                font-weight: ${e.fontWeight} !important;
                margin-bottom: 10px !important;
                margin-top: 10px !important;
                cursor: pointer;`
        ),
        "PERCENT" === e.heightType)
      ) {
        let s = t(`.${i}`).parent().height();
        t(`.${i}`).height(`${(s * e.height) / 100}px`);
      }
    }
    removeCartAlertListener() {
      t(this.button).parent().off("click", this.cartAlertModalClickHandler);
    }
    closeCartAlertModal(e, i = {}) {
      window.sessionStorage.setItem(
        "showCartAlert",
        JSON.stringify({
          ...i,
          [e.id]: { dismiss: t("#md-stop").is(":checked") },
        })
      ),
        t("#md-stop").is(":checked") && this.removeCartAlertListener();
    }
    addCartAlertListener(e, i) {
      let s =
          JSON.parse(window.sessionStorage.getItem("showCartAlert") || null) ||
          {},
        a =
          JSON.parse(window.sessionStorage.getItem("closedModals") || null) ||
          [],
        o = `${e.type}-${i.id}-${i.variantId}`;
      !(
        !e.cart.alert ||
        !e.cart.alert.isEnabled ||
        !0 !== e.cart.alert.onButtonClick ||
        s[o]?.dismiss ||
        a.includes(o)
      ) &&
        ((this.cartAlertModalClickHandler = () => {
          let t = { ...e.cart.alert, id: o };
          return new n().display(t, () => this.closeCartAlertModal(t, s));
        }),
        t(this.button).parent().on("click", this.cartAlertModalClickHandler));
    }
  }
  class m {
    constructor(t, e) {
      (this.timerSelector = t),
        (this.utils = { delims: [60, 60, 24, 365] }),
        (this.components = {
          timer: null,
          timerElements: [null, null, null, null],
        }),
        (this.componentsClasses = {
          timer: `timer-container-${e}`,
          title: "timer-title",
          subheading: "timer-subheading",
          timerValueContainer: "timer-value-container",
          timerLabels: "timer-value-labels",
          timerValues: "timer-values",
        });
    }
    setTimerInfo({
      content: t,
      isEnabled: e,
      placement: i,
      style: s,
      productConfig: a,
    }) {
      (this.title = t.title),
        (this.subheading = t.subheading),
        (this.labels = t.labels),
        (this.dates = t?.dates),
        (this.placement = i),
        (this.isEnabled = e || !1),
        (this.style = s || null),
        (this.onceItEnds = t.onceItEnds),
        (this.productConfig = a);
    }
    show() {
      if (!this.isEnable()) return !1;
      this.createTimer(),
        "BELOW" === this.placement
          ? t(this.timerSelector).after(this.components.timer)
          : t(this.timerSelector).before(this.components.timer),
        this.applyStyles(),
        this.countdown();
    }
    hide() {
      this.stop(), t(`.${this.componentsClasses.timer}`).remove();
    }
    createTitle() {
      return t(
        `<h2 class="${this.componentsClasses.title}">${this.title}</h2>`
      );
    }
    createSubheading() {
      return t(
        `<p class="${this.componentsClasses.subheading}">${this.subheading}</p>`
      );
    }
    createTimerLabels() {
      let e = [];
      for (let i of ["days", "hours", "mins", "secs"])
        e.push(
          t(
            `<div class="${this.componentsClasses.timerLabels}">${this.labels[i]}</div>`
          )
        );
      return e;
    }
    createTimerValues() {
      let e = [];
      return (
        ["00", ":", "00", ":", "00", ":", "00"].forEach((i) =>
          e.push(
            t(
              `<div translate="no" class="${this.componentsClasses.timerValues}">${i}</div>`
            )
          )
        ),
        (this.components.timerElements = e.filter((t, e) => e % 2 == 0)),
        e
      );
    }
    createTimerValueContainer() {
      let e = t(
        `<div class="${this.componentsClasses.timerValueContainer}"></div>`
      );
      return (
        e.append(...this.createTimerValues(), ...this.createTimerLabels()), e
      );
    }
    createTimer() {
      let e = t(`<div class="${this.componentsClasses.timer}"></div>`);
      return (
        e.append(
          this.createTitle(),
          this.createSubheading(),
          this.createTimerValueContainer()
        ),
        (this.components.timer = e),
        e
      );
    }
    getEndDateFromPeriod(t, e) {
      let i = parseInt(Date.now() / 1e3),
        s = 86400 * parseInt(e);
      switch (t) {
        case "MONTH":
          return i + 30 * s;
        case "WEEK":
          return i + 7 * s;
        default:
          return i + s;
      }
    }
    getActualEndDate() {
      switch (this.dates.endAt) {
        case "END_DATE":
          return (
            (this.productConfig.hasEndDate && this.productConfig.endDate) ||
            parseInt(Date.now() / 1e3)
          );
        case "SHIPPING_DATE":
          switch (this.productConfig.shippingDate.type) {
            case "PERIOD":
              return this.getEndDateFromPeriod(
                this.productConfig.shippingDate.periodType,
                this.productConfig.shippingDate.periodValue
              );
            case "INTERVAL":
              return this.getEndDateFromPeriod(
                this.productConfig.shippingDate.periodEnd.type,
                this.productConfig.shippingDate.periodEnd.value
              );
            default:
              return (
                this.productConfig.shippingDate.date ||
                parseInt(Date.now() / 1e3)
              );
          }
        default:
          if ("FIXED" === this.dates.type)
            return (
              parseInt(Date.now() / 1e3) + 60 * parseInt(this.dates.minutes)
            );
          return this.dates.endDate._seconds;
      }
    }
    isEnable() {
      return (
        !(this.getActualEndDate() < Date.now() / 1e3) &&
        (this.dates?.startDate
          ? this.isEnabled && this.dates.startDate._seconds < Date.now() / 1e3
          : this.isEnabled)
      );
    }
    make2Digit(t) {
      return `${t < 10 ? "0" : ""}${t}`;
    }
    handleOnEnd() {
      let { value: t, customTitle: e } = this.onceItEnds;
      switch (t) {
        case "unpublish-timer":
          return this.hide();
        case "repeat-the-countdown":
          if (
            "FIXED" !== this.dates.type ||
            (this.dates.endAt && "DATE" !== this.dates.endAt)
          )
            return;
          return (
            (this.dates.endDate._seconds = this.getActualEndDate()),
            setTimeout(() => this.countdown(), 500)
          );
        case "show-custom-title":
          return this.components.timer.html(e);
      }
    }
    calculateRelativeDatetime(t, e) {
      if ("number" != typeof t || "number" != typeof e || t - e <= 0)
        return ["00", "00", "00", "00"];
      let i = [0, 0, 0, 0],
        s = Math.abs(t - e);
      for (let a = 0; a < this.utils.delims.length; a++) {
        let o = this.utils.delims[a];
        if (((i[a] = Math.floor(s % o)), s >= o)) {
          s /= o;
          continue;
        }
        break;
      }
      return i.map((t) => this.make2Digit(t)).reverse();
    }
    countdown() {
      let t = [],
        e = parseInt(Date.now() / 1e3),
        i = this.getActualEndDate();
      this.timerId = setInterval(() => {
        if (i < e) return this.handleOnEnd(), this.stop();
        let s = this.calculateRelativeDatetime(i, e);
        this.components.timerElements.forEach((e, i) => {
          t[i] !== s[i] && e.text(s[i]);
        }),
          (t = s),
          (e += 1);
      }, 1e3);
    }
    stop() {
      clearInterval(this.timerId);
    }
    applyStyles() {
      t(`.${this.componentsClasses.timer} *`).css({
        margin: 0,
        padding: 0,
        "box-sizing": "border-box",
      }),
        t(`.${this.componentsClasses.timer}`).css({
          "max-width": "420px",
          "min-width": "260px",
          display: "flex",
          "flex-flow": "column",
          "text-align": "center",
          "-webkit-box-align": "center",
          "align-items": "center",
          overflow: "hidden",
          "margin-bottom": `${this.style.container?.marginBottom}px`,
          "margin-top": `${this.style.container?.marginTop}px`,
          "padding-bottom": `${this.style.container?.paddingBottom}px`,
          "padding-top": `${this.style.container?.paddingTop}px`,
          "background-color": this.style.container?.background,
          "border-color": this.style.container?.borderColor,
          "border-radius": `${this.style.container?.borderRadius}px`,
          "border-width": `${this.style.container?.borderSize}px`,
          "border-style": "solid",
        }),
        t(`.${this.componentsClasses.title}`).css({
          "font-weight": "bold",
          color: this.style.title?.color,
          "font-size": `${this.style.title?.fontSize}px`,
        }),
        t(`.${this.componentsClasses.subheading}`).css({
          "padding-top": "2px",
          "line-height": "1.5",
          color: this.style.subheading?.color,
          "font-size": `${this.style.subheading?.fontSize}px`,
        }),
        t(`.${this.componentsClasses.timerValueContainer}`).css({
          display: "grid",
          "grid-template-columns": "1fr 10px 1fr 10px 1fr 10px 1fr",
          gap: "6px 2px",
          "place-items": "center",
          "align-items": "flex-start",
        }),
        t(`.${this.componentsClasses.timerValues}`).css({
          "font-weight": "bold",
          "font-feature-settings": "tnum",
          "font-variant-numeric": "tabular-nums",
          "letter-spacing": "-2px",
          "line-height": "1",
          color: this.style.timer?.color,
          "font-size": `${this.style.timer?.fontSize}px`,
        }),
        t(`.${this.componentsClasses.timerLabels}`).css({
          "max-width": "100px",
          "white-space": "pre-line",
          "grid-column": "span 2 / auto",
          "text-align": "center",
          "padding-right": "10px",
          "line-height": "1",
          color: this.style.labels?.color,
          "font-size": `${this.style.labels?.fontSize}px`,
        }),
        t(`.${this.componentsClasses.timerLabels}:last-of-type`).css({
          "grid-column": "span 1 / auto",
          "padding-right": 0,
        });
    }
  }
  class h {
    constructor(t) {
      this.locale = t;
    }
    addStylePreorderMessage(e, i) {
      t(`.timesact-${i}-description`).css({
        "font-size": `${e.fontSize}px`,
        color: e.fontColor,
        "text-align": e.textAlign,
        "font-weight": e.fontWeight,
        "font-style": e.fontStyle,
        "margin-bottom": "10px",
        "margin-top": "10px",
      });
    }
    populateDynamicValues(t, e, i, s) {
      return (e = (e = (e = (e = e.replace(
        "{{preorderQuantity}}",
        this.getQuantity(t, i, s)
      )).replace(
        "{{shippingDate}}",
        this.getShippingDate(t[s].shippingDate, i)
      )).replace(
        "{{daysLeftUntilShippingDate}}",
        this.getDaysLeftUntilShippingDate(t[s].shippingDate, i)
      )).replace(
        "{{daysLeftUntilPreorderEndDate}}",
        this.getDaysLeftUntilEndDate(t[s], i)
      ));
    }
    getQuantity(t, e, i) {
      return "STOCK3" == t[i].stock.option
        ? t.quantity
        : t[i].stock.hasUnlimitedQuantity
        ? e
          ? "VARIABLE_NOT_SET"
          : '<span style="color:red;">VARIABLE_NOT_SET</span>'
        : t[i].stock.quantity;
    }
    getShippingDate(t, e) {
      if (!t || "NO_SET" === t.type)
        return e
          ? "VARIABLE_NOT_SET"
          : '<span style="color:red;">VARIABLE_NOT_SET</span>';
      if ("DATE" === t.type) {
        let i = new Date(1e3 * t.date);
        return i.toLocaleDateString(this.locale, {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      }
      if ("PERIOD" === t.type) {
        var s = 1;
        switch (t.periodType) {
          case "DAY":
            s = t.periodValue;
            break;
          case "WEEK":
            s = 7 * t.periodValue;
            break;
          case "MONTH":
            s = 30 * t.periodValue;
        }
        var a = new Date();
        return (
          a.setDate(a.getDate() + s),
          a.toLocaleDateString(this.locale, {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
        );
      }
      if ("INTERVAL" === t.type) {
        var o = 1,
          r = 1;
        switch (t.periodStart.type) {
          case "DAY":
            o = t.periodStart.value;
            break;
          case "WEEK":
            o = 7 * t.periodStart.value;
            break;
          case "MONTH":
            o = 30 * t.periodStart.value;
        }
        switch (t.periodEnd.type) {
          case "DAY":
            r = t.periodEnd.value;
            break;
          case "WEEK":
            r = 7 * t.periodEnd.value;
            break;
          case "MONTH":
            r = 30 * t.periodEnd.value;
        }
        var n = new Date();
        n.setDate(n.getDate() + o);
        var l = new Date();
        return (
          l.setDate(l.getDate() + r),
          n.toLocaleDateString(this.locale, {
            day: "numeric",
            month: "long",
            year: "numeric",
          }) +
            " - " +
            l.toLocaleDateString(this.locale, {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
        );
      }
    }
    getDaysLeftUntilShippingDate(t, e) {
      if (!t || "NO_SET" === t.type)
        return e
          ? "VARIABLE_NOT_SET"
          : '<span style="color:red;">VARIABLE_NOT_SET</span>';
      let i = new Date();
      if ("DATE" === t.type) {
        let s = new Date(1e3 * t.date);
        return Math.ceil((s.getTime() - i.getTime()) / 864e5);
      }
      if ("PERIOD" === t.type)
        switch (t.periodType) {
          case "DAY":
            return t.periodValue;
          case "WEEK":
            return 7 * t.periodValue;
          case "MONTH":
            return 30 * t.periodValue;
          default:
            return 1;
        }
      if ("INTERVAL" === t.type) {
        var a = 1,
          o = 1;
        switch (t.periodStart.type) {
          case "DAY":
            a = t.periodStart.value;
            break;
          case "WEEK":
            a = 7 * t.periodStart.value;
            break;
          case "MONTH":
            a = 30 * t.periodStart.value;
        }
        switch (t.periodEnd.type) {
          case "DAY":
            o = t.periodEnd.value;
            break;
          case "WEEK":
            o = 7 * t.periodEnd.value;
            break;
          case "MONTH":
            o = 30 * t.periodEnd.value;
        }
        return a + " - " + o;
      }
    }
    getDaysLeftUntilEndDate(t, e) {
      if (!t.hasEndDate)
        return e
          ? "VARIABLE_NOT_SET"
          : '<span style="color:red;">VARIABLE_NOT_SET</span>';
      let i = new Date(),
        s = new Date(1e3 * t.endDate);
      return Math.ceil((s.getTime() - i.getTime()) / 864e5);
    }
  }
  class b {
    constructor(e, i, s, a) {
      (this.selectors = e),
        (this.product = i),
        (this.settings = window.ta.settings),
        (this.defaultSettingIds = s),
        (this.buttonPO = new u(
          this.selectors.buttonSelector,
          "timesact-button-po"
        )),
        (this.buttonIS = new u(
          this.selectors.buttonSelector,
          "timesact-button-is"
        )),
        (this.buttonBIS = new u(
          this.selectors.buttonSelector,
          "timesact-button-bis"
        )),
        (this.buttonCS = new u(
          this.selectors.buttonSelector,
          "timesact-button-cs"
        )),
        (this.timerPO = new m(
          this.selectors.timerSelector,
          "timesact-timer-po"
        )),
        (this.timerIS = new m(
          this.selectors.timerSelector,
          "timesact-timer-is"
        )),
        (this.timerBIS = new m(
          this.selectors.timerSelector,
          "timesact-timer-bis"
        )),
        (this.timerCS = new m(
          this.selectors.timerSelector,
          "timesact-timer-cs"
        )),
        (this.uuid = Math.floor(1e8 + 9e8 * Math.random())),
        t(this.selectors.variantSelector).addClass(
          "timesact-variant-picker-" + this.uuid
        ),
        (this.shop = a);
    }
    init() {
      this.createWidget(), new g().initVariantEventListener(this);
    }
    createWidget() {
      let e = this.product.timesactVariants[this.product.variantId];
      if (this.product.isBISEnabledForVariant()) {
        let i = this.product.getVariantSettings(
          this.settings,
          this.defaultSettingIds.BIS,
          "BIS"
        );
        this.buttonBIS.setAddToCartText(i.button.addToCartText),
          this.buttonBIS.setSoldOutText(i.button.soldOutText),
          "ACTIVE" === e.configBIS.status &&
            (this.buttonBIS.showBIS(i), this.addCommonElements(i, e));
      }
      if (this.product.isISEnabledForVariant()) {
        let s = this.product.getVariantSettings(
          this.settings,
          this.defaultSettingIds.IS,
          "IS"
        );
        if (
          (this.buttonIS.setAddToCartText(s.button.addToCartText),
          this.buttonIS.setSoldOutText(s.button.soldOutText),
          "NO_STOCK" === e.configIS.status &&
            (this.buttonIS.showOutOfStock(),
            t(this.selectors.formSelector)
              .find(".shopify-payment-button")
              .hide()),
          "ACTIVE" === e.configIS.status)
        ) {
          this.buttonIS.confirmButtonExists() ||
            (this.buttonIS.identifyButton(this.selectors),
            (this.selectors.buttonSelector = t(
              this.selectors.formSelector
            ).find(this.selectors.ids.addToCartButton))),
            this.buttonIS.showPO(s),
            this.buttonIS.addCartAlertListener(s, this.product),
            this.shop.isDisabledIS && this.buttonIS.disable(),
            this.addCommonElements(s, e);
          let a = new h(s.message.locale || "en-US"),
            o = a.populateDynamicValues(
              e,
              s.cart.labelText.key,
              !0,
              "configIS"
            ),
            r = a.populateDynamicValues(
              e,
              s.cart.labelText.value,
              !0,
              "configIS"
            );
          (void 0 === s.cart.labelText.isEnabled ||
            s.cart.labelText.isEnabled) &&
            this.showPreorderLineItemProperty(o, r);
        }
      }
      if (this.product.isPOEnabledForVariant()) {
        let n = this.product.getVariantSettings(
          this.settings,
          this.defaultSettingIds.PO,
          "PO"
        );
        if (
          (this.buttonPO.setAddToCartText(n.button.addToCartText),
          this.buttonPO.setSoldOutText(n.button.soldOutText),
          "NO_STOCK" === e.config.status &&
            (this.buttonPO.showOutOfStock(),
            t(this.selectors.formSelector)
              .find(".shopify-payment-button")
              .hide()),
          "ACTIVE" === e.config.status)
        ) {
          this.buttonPO.confirmButtonExists() ||
            (this.buttonPO.identifyButton(this.selectors),
            (this.selectors.buttonSelector = t(
              this.selectors.formSelector
            ).find(this.selectors.ids.addToCartButton))),
            this.shop.hasSellingPlanEnabled &&
              this.product.sellingPlans.length > 0 &&
              !this.shop.isSellingPlanUIDisabled &&
              this.addSellingPlan(this.product.sellingPlans, n, e),
            this.buttonPO.showPO(n),
            this.buttonPO.addCartAlertListener(n, this.product),
            this.shop.isDisabled && this.buttonPO.disable(),
            this.addCommonElements(n, e);
          let l = new h(n.message.locale || "en-US"),
            d = l.populateDynamicValues(e, n.cart.labelText.key, !0, "config"),
            c = l.populateDynamicValues(
              e,
              n.cart.labelText.value,
              !0,
              "config"
            );
          (void 0 === n.cart.labelText.isEnabled ||
            n.cart.labelText.isEnabled) &&
            this.showPreorderLineItemProperty(d, c),
            e.config.stock.hasUnlimitedQuantity ||
              this.addQuantityListener(e.config.stock.quantity);
        }
      }
      if (this.product.isCSEnabledForVariant()) {
        let p = this.product.getVariantSettings(
          this.settings,
          this.defaultSettingIds.CS,
          "CS"
        );
        this.buttonCS.setAddToCartText(p.button.addToCartText),
          this.buttonCS.setSoldOutText(p.button.soldOutText),
          "ACTIVE" === e.configCS.status &&
            (this.buttonCS.showCS(p), this.addCommonElements(p, e));
      }
    }
    resetDefault() {
      this.buttonBIS.hide(),
        this.buttonCS.hide(),
        this.timerPO.hide(),
        this.timerIS.hide(),
        this.timerBIS.hide(),
        this.timerCS.hide(),
        this.buttonPO.removeCartAlertListener(),
        this.buttonIS.removeCartAlertListener(),
        (this.buttonPO.confirmButtonExists() &&
          this.buttonIS.confirmButtonExists()) ||
          (this.buttonPO.identifyButton(this.selectors),
          this.buttonIS.identifyButton(this.selectors),
          (this.selectors.buttonSelector = t(this.selectors.formSelector).find(
            this.selectors.ids.addToCartButton
          ))),
        this.product.isVariantOutOfStock()
          ? (this.buttonPO.showOutOfStock(),
            t(this.selectors.formSelector)
              .find(".shopify-payment-button")
              .hide())
          : (this.buttonPO.showAddToCart(),
            t(this.selectors.formSelector)
              .find(".shopify-payment-button")
              .show()),
        this.removePreorderLineItemProperty(),
        this.removePreorderMessage(),
        this.removePreorderBadge(),
        this.removePreorderQuantity(),
        this.removeSellingPlanWidget(),
        this.selectors.hideProductElements && this.addHiddenElements();
    }
    addSellingPlan(e, i, a) {
      if (!a.config.sellingPlan) {
        console.log("Variant has no SellingPlan set.");
        return;
      }
      let o = e.find((t) => String(t.id) === a.config.sellingPlan);
      if (!o) {
        console.log("SellingPlan was not found.");
        return;
      }
      "FULL_PAYMENT" === o.options[0].name
        ? this.addHiddenSellingPlan(o.id)
        : (t(this.selectors.sellingPlanSelector).before(s),
          t("#timesact_widget .timesact_text").text(o.options[0].value),
          t("#timesact_widget #timesact_selling_plan_label").val(o.id));
      let r = new h(i.locale || "en-US");
      this.showPreorderMessage(i.message.type, o.description, "selling-plan"),
        r.addStylePreorderMessage(i.message, "selling-plan");
    }
    static displayBisModal() {
      let {
          defaultSettings: e,
          productId: i,
          productVariants: s,
          variantId: a,
        } = window.ta.currentTimesactProductData,
        o = new l(i, s);
      o.setActiveVariant(a), o.setTimesactVariants({ variants: s });
      let { form: r } = o.getVariantSettings(
        window.ta.settings,
        e.templates.BIS,
        "BIS"
      );
      t("h3.timesact_bis_heading").attr(
        "style",
        `color: ${r.headingFontColor} !important;`
      ),
        t("#subscriptionForm .timesact_bis_submit_button").attr(
          "style",
          `
				background: ${r.buttonBackgroundColor} !important;
				color: ${r.buttonFontColor} !important;
				border-radius: ${r.fieldsBorderRadius}px !important;
				font-size: ${r.fontSize}px !important;`
        ),
        t("#subscriptionForm .timesact_bis_input").attr(
          "style",
          `
				border-radius: ${r.fieldsBorderRadius}px !important;
				font-size: ${r.fontSize}px !important;`
        ),
        t(".timesact_bis_popup").attr(
          "style",
          `border-radius: ${r.popupBorderRadius}px !important;`
        ),
        t(
          ".timesact_bis_desc, .timesact_bis_note, .timesact_bis_subscribe"
        ).attr("style", `color: ${r.textFontColor} !important;`),
        t(".timesact_bis_email").attr(
          "style",
          `border-radius: ${r.fieldsBorderRadius}px !important;`
        ),
        t(".timesact_bis_heading").text(r.heading),
        t(".timesact_bis_desc").text(r.description),
        t(".timesact_bis_submit_button").text(r.buttonName),
        t(".timesact_bis_form_field .timesact_bis_note").text(r.note),
        t(".timesact_bis_form_field .timesact_bis_subscribe").text(
          r.messageNewsletter
        ),
        t(".timesact_bis_message_success").text(r.messageSuccess),
        t(".timesact_bis_message_error").text(r.messageError),
        r.isNewsletterEnabled ||
          t(".timesact_sub").attr("style", "display: none;"),
        t(".timesact_bis_popup_overlay").addClass(
          "timesact_bis_popup_overlay_show"
        ),
        t(".timesact_bis_dialog").addClass("timesact_bis_dialog_show"),
        r.isBrandEnabled || t(".timesact_powered_by").hide();
    }
    addHiddenSellingPlan(e) {
      t(this.selectors.formSelector).append(
        `<input type="hidden" checked="checked" data-timesact-selling-plan name="selling_plan" value="${e}" id="selling_plan_${e}">`
      );
    }
    addCommonElements(e, i) {
      let s =
        "BIS" === e.type
          ? "bis"
          : "CS" === e.type
          ? "cs"
          : "IS" === e.type
          ? "is"
          : "preorder";
      "is" !== s &&
        t(this.selectors.formSelector).find(".shopify-payment-button").hide(),
        this.addPreorderMessage(e.message, i, s),
        e.badge.product &&
          this.addBadge(this.selectors.badgeSelector, e.badge, s),
        this.selectors.hideProductElements &&
          t(this.selectors.hideProductElements).hide();
      let a = e.message.timer;
      if (a) {
        let o = "PO" !== e.type ? e.type : "";
        this[`timer${e.type}`].setTimerInfo({
          ...a,
          productConfig: i[`config${o}`],
        }),
          this[`timer${e.type}`].show();
      }
    }
    showPreorderLineItemProperty(e, i) {
      0 === t(this.selectors.formSelector).find("#preorder-label").length
        ? t(this.selectors.formSelector).append(
            '<input type="hidden" id="preorder-label" name="properties[' +
              e +
              ']" value="' +
              i +
              '" />'
          )
        : t(this.selectors.formSelector).find("#preorder-label").val(i);
    }
    removePreorderLineItemProperty() {
      t(this.selectors.formSelector).find("#preorder-label").remove();
    }
    removePreorderBadge() {
      t(this.selectors.badgeSelector)
        .find(
          ".timesact-badge-ribbon-preorder, .timesact-badge-ribbon-bis, .timesact-badge-ribbon-cs, .timesact-badge-ribbon-is"
        )
        .remove(),
        t(this.selectors.badgeSelector)
          .find(
            ".timesact-badge-common-preorder, .timesact-badge-common-bis, .timesact-badge-common-cs, .timesact-badge-common-is"
          )
          .remove();
    }
    removeSellingPlanWidget() {
      t("#timesact_widget").remove(),
        t(".timesact-selling-plan-description").remove(),
        t("[data-timesact-selling-plan]").remove();
    }
    addBadge(t, e, i) {
      let s = new r();
      s.add(t, e.type, e.value, i), s.applyStyles(e, i);
    }
    addPreorderMessage(t, e, i) {
      let s = new h(t.locale || "en-US");
      if ("" != t.value) {
        let a = s.populateDynamicValues(
          e,
          t.value,
          !1,
          "bis" === i
            ? "configBIS"
            : "cs" === i
            ? "configCS"
            : "is" === i
            ? "configIS"
            : "config"
        );
        this.showPreorderMessage(t.type, a, i), s.addStylePreorderMessage(t, i);
      }
    }
    showPreorderMessage(e, i, s) {
      if (this.selectors.messageSelector) {
        0 ===
        t(this.selectors.formSelector).find(`.timesact-${s}-description`).length
          ? "BELOW" === e
            ? t(this.selectors.messageSelector).after(
                `<div class='timesact-${s}-description'>` + i + "</div>"
              )
            : t(this.selectors.messageSelector).before(
                `<div class='timesact-${s}-description'>` + i + "</div>"
              )
          : t(this.selectors.formSelector)
              .find(`.timesact-${s}-description`)
              .val(i);
        return;
      }
      0 ===
      t(this.selectors.formSelector).find(`.timesact-${s}-description`).length
        ? "BELOW" === e
          ? t(this.selectors.buttonSelector).after(
              `<div class='timesact-${s}-description'>` + i + "</div>"
            )
          : t(this.selectors.buttonSelector).before(
              `<div class='timesact-${s}-description'>` + i + "</div>"
            )
        : t(this.selectors.formSelector)
            .find(`.timesact-${s}-description`)
            .val(i);
    }
    removePreorderMessage() {
      t(this.selectors.formSelector)
        .find(
          ".timesact-preorder-description, .timesact-bis-description, .timesact-cs-description, .timesact-is-description"
        )
        .remove();
    }
    removePreorderQuantity() {
      t(".timesact-quantity-message").remove(),
        t(this.selectors.quantitySelector).off("change.quantityChange"),
        t(this.selectors.buttonSelector).off("click.quantityButtonClick");
    }
    addHiddenElements() {
      t(this.selectors.hideProductElements).show();
    }
    addQuantityListener(e) {
      let i = this.selectors;
      t(this.selectors.quantitySelector).on(
        "change.quantityChange",
        function () {
          e < parseInt(t(this).val())
            ? (t(".timesact-quantity-message").length ||
                (i.messageSelector
                  ? t(i.messageSelector).before(
                      `<div class='timesact-quantity-message' style='color:red'>You can only pre-order ${e} items!</div>`
                    )
                  : t(i.buttonSelector).before(
                      `<div class='timesact-quantity-message' style='color:red'>You can only pre-order ${e} items!</div>`
                    )),
              t(i.buttonSelector).prop("disabled", !0))
            : (t(".timesact-quantity-message").remove(),
              t(i.buttonSelector).prop("disabled", !1));
        }
      ),
        t(this.selectors.buttonSelector).on(
          "click.quantityButtonClick",
          function (s) {
            let a = t(i.quantitySelector).val();
            e < parseInt(a)
              ? (s.preventDefault(),
                t(".timesact-quantity-message").length ||
                  (i.messageSelector
                    ? t(i.messageSelector).before(
                        `<div class='timesact-quantity-message' style='color:red'>You can only pre-order ${e} items!</div>`
                      )
                    : t(i.buttonSelector).before(
                        `<div class='timesact-quantity-message' style='color:red'>You can only pre-order ${e} items!</div>`
                      )))
              : t(".timesact-quantity-message").remove();
          }
        );
    }
  }
  class g {
    initVariantEventListener(e) {
      var i = this;
      t(document).on(
        "change",
        ".timesact-variant-picker-" + e.uuid,
        function (t) {
          i.variantChangeHandler(e);
        }
      ),
        i.setup(function () {
          i.variantChangeHandler(e);
        });
    }
    sleep(t) {
      return new Promise(function (e) {
        setTimeout(e, t);
      });
    }
    variantChangeHandler(e) {
      let i = e;
      this.sleep(e.selectors.variantChangingTime).then(function () {
        var e = window.location.search.replace(/.*variant=(\d+).*/, "$1");
        e ||
          (e =
            "radio" ===
            t(i.selectors.formSelector)
              .find(
                "select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']"
              )
              .attr("type")
              ? t(i.selectors.formSelector)
                  .find("input[name='id']:checked, input[name='id[]']:checked")
                  .val()
              : t(i.selectors.formSelector)
                  .find(
                    "select[name='id'], input[name='id'], select[name='id[]'], input[name='id[]']"
                  )
                  .val()),
          i.product.setActiveVariant(e),
          i.resetDefault(),
          i.createWidget();
      });
    }
    track(t, e, i) {
      return function s() {
        if (i) return e.apply(this, arguments), t.apply(this, arguments);
        var a = t.apply(this, arguments);
        return e.apply(this, arguments), a;
      };
    }
    setup(t) {
      (history.pushState = this.track(history.pushState, t)),
        (history.replaceState = this.track(history.replaceState, t)),
        window.addEventListener("popstate", t);
    }
  }
  class f {
    static async createSubscription(e) {
      try {
        return (
          await t.ajax({
            url: "/apps/timesact/notifications/bis",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(e),
          }),
          !0
        );
      } catch (i) {
        return console.log("Subscription no create", i), !1;
      }
    }
    static async getProductPreOrderConfig(e) {
      try {
        return await t.ajax({
          url: `/apps/timesact/config?productId=${e}`,
          type: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      } catch (i) {
        return console.log("Product is not active on pre-order."), null;
      }
    }
    async getProducts(e = []) {
      try {
        return await t.ajax({
          url: `/apps/timesact/products?productIds=${e}`,
          type: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      } catch (i) {
        return console.log("Products config couldn't be fetched."), null;
      }
    }
    async getShop() {
      try {
        return await t.ajax({
          url: "/apps/timesact/shop",
          type: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      } catch (e) {
        return console.log("Shop data couldn't be fetched."), null;
      }
    }
    async getSettings() {
      try {
        return await t.ajax({
          url: "/apps/timesact/shop/settings",
          type: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      } catch (e) {
        return console.log("Settings data couldn't be fetched."), null;
      }
    }
  }
  class v {
    constructor(t) {
      this.ids = t;
    }
    setNormalSelectors() {
      (this.formSelector = t(this.ids.form)),
        (this.buttonSelector = this.formSelector.find(
          this.ids.addToCartButton
        )),
        0 === this.buttonSelector.length &&
          (this.buttonSelector = this.formSelector
            .find(
              '[type="submit"]:visible:first, [name="add"], .product-submit, .addtocart-button-active, .product-form--add-to-cart, .button--addToCart, .product-form__submit, .add-to-cart, .btn-addtocart, .single_add_to_cart_button, .product-form__cart-submit, .product-form--atc-button, .ProductForm__AddToCart, [type="button"]:visible:first'
            )
            .first()),
        (this.variantSelector = this.formSelector.find(this.ids.variant)),
        this.ids.quantity
          ? (this.quantitySelector = this.formSelector.find(this.ids.quantity))
          : ((this.quantitySelector =
              this.formSelector.find('[name="quantity"]')),
            0 === this.quantitySelector.length &&
              (this.quantitySelector = t('[name="quantity"]'))),
        this.ids.badge
          ? (this.badgeSelector = t(this.ids.badge))
          : (this.badgeSelector = t(".timesact-badge")),
        this.ids.message &&
          (this.messageSelector = this.formSelector.find(this.ids.message)),
        (this.sellingPlanSelector = this.formSelector.find(
          '[type="submit"]:visible:first'
        )),
        this.ids.sellingPlan &&
          (this.sellingPlanSelector = this.formSelector.find(
            this.ids.sellingPlan
          )),
        (this.timerSelector = this.formSelector.find(
          '[type="submit"]:visible:first'
        )),
        this.ids.timer &&
          (this.timerSelector = this.formSelector.find(this.ids.timer)),
        this.ids.hide &&
          this.ids.hide.product &&
          (this.hideProductElements = this.ids.hide.product),
        (this.variantChangingTime = this.ids.variantChangingTime || 250),
        this.formSelector.find(
          '[data-pf-type="ProductATC"], [data-pf-type="ProductATC2"]'
        ).length > 0 &&
          ((this.buttonSelector = this.formSelector.find(
            '[data-pf-type="ProductATC"] span:first, [data-pf-type="ProductATC2"] span:first'
          )),
          (this.messageSelector = this.formSelector.find(
            this.ids.message || '[data-pf-type="ProductATC"]'
          )),
          (this.badgeSelector = t('[data-pf-type="MainMedia"]')));
    }
    setQuickViewSelectors() {
      (this.formSelector = t(
        window.ta.quickView.selectors.quickviewModalContainer
      ).find(window.ta.quickView.selectors.form)),
        (this.buttonSelector = t(
          window.ta.quickView.selectors.quickviewModalContainer
        ).find(window.ta.quickView.selectors.addToCartButton)),
        (this.variantSelector = t(
          window.ta.quickView.selectors.quickviewModalContainer
        ).find(window.ta.quickView.selectors.variant)),
        (this.quantitySelector = t(
          window.ta.quickView.selectors.quickviewModalContainer
        ).find(window.ta.quickView.selectors.quantity)),
        this.ids.message &&
          (this.messageSelector = this.formSelector.find(this.ids.message)),
        (this.variantChangingTime = this.ids.variantChangingTime || 250),
        this.ids.badge
          ? (this.badgeSelector = t(this.ids.badge))
          : (this.badgeSelector = t(".timesact-badge")),
        (this.sellingPlanSelector = this.formSelector.find(
          '[type="submit"]:visible:first'
        )),
        this.ids.sellingPlan &&
          (this.sellingPlanSelector = t(this.ids.sellingPlan));
    }
  }
  class y {
    constructor(t, e) {
      (this.shop = t), (this.product = e);
    }
    async run(t) {
      let e = await f.getProductPreOrderConfig(this.product.id);
      if (!e) {
        (window.ta.products[this.product.id] = {
          isPreorder: !1,
          isBIS: !1,
          isCS: !1,
          isIS: !1,
          lastUpdate: parseInt(new Date().getTime() / 1e3),
        }),
          localStorage.setItem("products", JSON.stringify(window.ta.products));
        return;
      }
      (window.ta.currentTimesactProductData = {
        defaultSettings: this.shop.settings,
        productId: this.product.id,
        productName: this.product.title,
        productVariants: e.product.variants,
        variantId: null,
      }),
        (this.selectors = new v(this.shop.selectors)),
        t
          ? this.selectors.setQuickViewSelectors()
          : this.selectors.setNormalSelectors(),
        this.product.setActiveVariant(
          new c().extractVariantId(
            this.product.variants,
            this.selectors.formSelector
          )
        ),
        this.product.setTimesactVariants(e.product);
      let i = new b(
        this.selectors,
        this.product,
        this.shop.settings.templates,
        this.shop
      );
      i.init(),
        (window.ta.products[this.product.id] = {
          isPreorder: this.isActiveOnPreorder(e.product.variants),
          isBIS: this.isActiveOnBIS(e.product.variants),
          isCS: this.isActiveOnCS(e.product.variants),
          isIS: this.isActiveOnIS(e.product.variants),
          variants: e.product.variants,
          lastUpdate: parseInt(new Date().getTime() / 1e3),
        }),
        localStorage.setItem("products", JSON.stringify(window.ta.products));
    }
    hasCustomSettings(t, e) {
      return (
        !!t.variants[e].settings && "CUSTOM" === t.variants[e].settings.type
      );
    }
    async getVariantSettings(t, e, i, s, a) {
      if (!i.variants[s].config.settingsTemplate) {
        if (!this.hasCustomSettings(i, s)) return e;
        let o = i.variants[s].settings;
        return {
          button: { ...e.button, name: o.buttonName || e.button.name },
          message: {
            ...e.message,
            type: o.messageType || e.message.type,
            value: o.messageValue || e.message.value,
          },
          cart: {
            ...e.cart,
            labelText: {
              key: o.cartLabelTextKey || e.cart.labelText.key,
              value: o.cartLabelTextValue || e.cart.labelText.value,
            },
          },
          badge: e.badge,
        };
      }
      return "PO" === a
        ? i.variants[s].config.settingsTemplate in t
          ? t[i.variants[s].config.settingsTemplate]
          : e
        : "BIS" === a
        ? i.variants[s].configBIS.settingsTemplate in t
          ? t[i.variants[s].configBIS.settingsTemplate]
          : e
        : "CS" === a && i.variants[s].configCS.settingsTemplate in t
        ? t[i.variants[s].configCS.settingsTemplate]
        : e;
    }
    addSellingPlan(e, i, a, o) {
      if (!a.config.sellingPlan) {
        console.log("Variant has no SellingPlan set.");
        return;
      }
      let r = e.find((t) => String(t.id) === a.config.sellingPlan);
      if (!r) {
        console.log("SellingPlan was not found.");
        return;
      }
      "FULL_PAYMENT" === r.options[0].name
        ? t(o).append(
            `<input type="hidden" checked="checked" data-timesact-selling-plan name="selling_plan" value="${r.id}" id="selling_plan_${r.id}">`
          )
        : (t(o).find(this.selectors.sellingPlanSelector).before(s),
          t("#timesact_widget .timesact_text").text(r.options[0].value),
          t("#timesact_widget #timesact_selling_plan_label").val(r.id));
      let n = new h(i.locale || "en-US");
      0 === t(o).find(".timesact-selling-plan-description").length
        ? t(o)
            .find(this.selectors.messageSelector)
            .after(
              "<div class='timesact-selling-plan-description'>" +
                r.description +
                "</div>"
            )
        : t(o).find(".timesact-selling-plan-description").val(r.description),
        n.addStylePreorderMessage(i.message, "selling-plan");
    }
    async runHomepage() {
      let e = this;
      (this.selectors = new v(this.shop.selectors)),
        this.selectors.setNormalSelectors();
      var i,
        s = new Set();
      let a = t(this.selectors.formSelector);
      for (var o = 0; o < a.length; o++) {
        let n = t(a[o]).data("productid");
        n && s.add(n);
      }
      let d = await new f().getProducts(Array.from(s));
      if (!d) {
        console.log("[Error] Timesact API getProducts.");
        return;
      }
      let c = window.ta.settings[this.shop.settings.templates.PO];
      for (var o = 0; o < a.length; o++) {
        let p = t(a[o]).data("productid");
        if (!(p in d.products)) continue;
        let u = d.products[p];
        this.shop.hasSellingPlanEnabled &&
          (await t.getJSON(
            window.Shopify.routes.root + `products/${u.handle}.js`,
            function (t) {
              i = new l(t.id, t.variants, t.title, t.selling_plan_groups);
            }
          ));
        let m = t(a[o]).find("[name='id']").val(),
          b = await this.getVariantSettings(window.ta.settings, c, u, m, "PO"),
          g = t(a[o]).find(this.selectors.buttonSelector);
        if (!m || "NO_STOCK" === u.variants[m].config.status) {
          t(g).val(b.button.soldOutText),
            t(g).text(b.button.soldOutText),
            t(g).prop("disabled", !0),
            t(a[o]).find(".timesact-preorder-description").remove(),
            t(a[o]).find("#preorder-label").remove(),
            t(a[o])
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .find(".timesact-badge-common")
              .remove();
          continue;
        }
        if ("ACTIVE" === u.variants[m].config.status) {
          t(g).val(b.button.name),
            t(g).text(b.button.name),
            t(g).prop("disabled", !1),
            t(a[o]).find(".shopify-payment-button").hide();
          let y = new h(c.message.locale || "en-US");
          if (
            void 0 === b.cart.labelText.isEnabled ||
            b.cart.labelText.isEnabled
          ) {
            let S = y.populateDynamicValues(
                u.variants[m],
                b.cart.labelText.key,
                !1,
                "config"
              ),
              $ = y.populateDynamicValues(
                u.variants[m],
                b.cart.labelText.value,
                !1,
                "config"
              );
            0 === t(a[o]).find("#preorder-label").length
              ? t(a[o]).append(
                  '<input type="hidden" id="preorder-label" name="properties[' +
                    S +
                    ']" value="' +
                    $ +
                    '" />'
                )
              : t(a[o]).find("#preorder-label").val($);
          }
          this.shop.hasSellingPlanEnabled &&
            this.addSellingPlan(i.sellingPlans, b, u.variants[m], a[o]);
          let w = y.populateDynamicValues(
            u.variants[m],
            b.message.value,
            !1,
            "config"
          );
          0 === t(a[o]).find(".timesact-preorder-description").length
            ? t(a[o])
                .find(this.selectors.messageSelector)
                .after(
                  "<div class='timesact-preorder-description'>" + w + "</div>"
                )
            : t(a[o]).find(".timesact-preorder-description").val(w),
            y.addStylePreorderMessage(b.message, "preorder");
          let x = new r();
          x.add(
            t(a[o])
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .find(".image--container:first"),
            b.badge.type,
            b.badge.value
          ),
            x.applyStyles(b.badge);
        }
        ("NO_SET" === u.variants[m].config.status ||
          "PENDING" === u.variants[m].config.status) &&
          (t(g).val(b.button.addToCartText),
          t(g).text(b.button.addToCartText),
          t(a[o]).find(".timesact-preorder-description").remove(),
          t(a[o]).find("#preorder-label").remove(),
          t(a[o])
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .find(".timesact-badge-common")
            .remove()),
          t(a[o])
            .parent()
            .parent()
            .parent()
            .find("[type='radio']")
            .on("click.variant", function () {
              e.runHomepage();
            });
      }
    }
    async runCollection() {
      if (
        window.ta.settings[this.shop.settings.templates.PO].badge.collection ||
        window.ta.settings[this.shop.settings.templates.BIS].badge.collection ||
        window.ta.settings[this.shop.settings.templates.CS].badge.collection ||
        window.ta.settings[this.shop.settings.templates.IS].badge.collection
      ) {
        this.shop.lastProductUpdate &&
          window.ta.lastProductUpdate < this.shop.lastProductUpdate &&
          (window.ta.products = {});
        let e = [
          ".timesact-badge",
          ".product-item",
          ".card--standard",
          ".card--card",
          ".ProductItem",
          '[data-pf-type="ProductBox"]',
        ];
        this.shop.selectors.collection &&
          this.shop.selectors.collection.badge &&
          (e = [this.shop.selectors.collection.badge]);
        let i = [];
        for (let s = 0; s < e.length; s++)
          if (t(e[s]).length > 0) {
            i = t(e[s]);
            break;
          }
        this.enableBadgeOnCollection(i);
      }
    }
    async runMixedCartAlert(e) {
      if (!window.ta.cart.showMixedCartAlert || !e.items.length) return;
      let i = window.location.pathname.includes("cart"),
        s = window.ta.settings[this.shop.settings.templates.PO];
      if (
        !s.cart.mixed.isEnabled ||
        (i && !1 === s.cart.mixed.onCartPage) ||
        (!i && !0 !== s.cart.mixed.onButtonClick)
      )
        return;
      let a = !1,
        o = !1,
        r = {};
      for (let l of e.items) {
        if (window.ta.products[l.product_id]) {
          if (
            window.ta.products[l.product_id].variants &&
            window.ta.products[l.product_id].variants[l.variant_id] &&
            "ACTIVE" ===
              window.ta.products[l.product_id].variants[l.variant_id].config
                .status
          ) {
            a = !0;
            continue;
          }
          o = !0;
          continue;
        }
        (r[l.product_id] = r[l.product_id] || []),
          r[l.product_id].push(l.variant_id);
      }
      let d = new n(),
        c = { ...s.cart.mixed, id: s.id || s.name },
        p = () => {
          window.sessionStorage.setItem(
            "showCartMixedAlert",
            !t("#md-stop").is(":checked")
          ),
            (window.ta.cart.showMixedCartAlert = !t("#md-stop").is(":checked"));
        };
      if (a && o) return d.display(c, p);
      if (!Object.keys(r).length) return;
      let u = await new f().getProducts(Object.keys(r));
      if (!u) {
        console.log("[Error] Timesact API getProducts.");
        return;
      }
      for (let m of Object.keys(r)) {
        if (!(m in u.products)) {
          (o = !0),
            (window.ta.products[m] = {
              isPreorder: !1,
              isBIS: !1,
              isCS: !1,
              lastUpdate: parseInt(new Date().getTime() / 1e3),
            });
          continue;
        }
        for (let h of r[m]) {
          if (
            u.products[m].variants[h] &&
            "ACTIVE" === u.products[m].variants[h].config.status
          ) {
            a = !0;
            continue;
          }
          o = !0;
        }
        if (
          ((window.ta.products[m] = {
            isPreorder: this.isActiveOnPreorder(u.products[m].variants),
            isBIS: this.isActiveOnBIS(u.products[m].variants),
            isCS: this.isActiveOnCS(u.products[m].variants),
            isIS: this.isActiveOnIS(u.products[m].variants),
            variants: u.products[m].variants,
            lastUpdate: parseInt(new Date().getTime() / 1e3),
          }),
          o && a)
        ) {
          d.display(c, p);
          break;
        }
      }
      localStorage.setItem("products", JSON.stringify(window.ta.products));
    }
    async runCartAlert(t) {
      if (!t.items.length) return;
      let e = {};
      for (var i of t.items) {
        let s = window.ta.products[i.product_id];
        if (!s) continue;
        let a = s?.variants?.[i.variant_id],
          o = s.isIS ? "configIS" : "config";
        a?.[o]?.status === "ACTIVE" &&
          (e[i.product_id] = { ...(e[i.product_id] || {}), [i.variant_id]: a });
      }
      if (!Object.keys(e).length) return;
      let r =
          JSON.parse(window.sessionStorage.getItem("showCartAlert") || null) ||
          {},
        l = {};
      for (let [d, c] of Object.entries(e))
        for (let [p, m] of Object.entries(c)) {
          let h = m.isISEnabled ? "configIS" : "config",
            b = window.ta.settings[m[h]?.settingsTemplate],
            g = `${b.type}-${d}-${p}`;
          l[g] = {
            dismiss: !!r[g]?.dismiss,
            settings: { id: g, ...b.cart?.alert },
          };
        }
      let f = (t) => () => {
        let e =
          JSON.parse(window.sessionStorage.getItem("showCartAlert") || null) ||
          {};
        return new u("", "").closeCartAlertModal(t, e);
      };
      for (let v of Object.values(l))
        v.settings.isEnabled &&
          !1 !== v.settings.onCartPage &&
          !v.dismiss &&
          n.pushQueue(v.settings, f(v.settings));
      n.showFirst();
    }
    isActiveOnPreorder(t) {
      return Object.values(t).every((t) => "ACTIVE" === t.config.status);
    }
    isActiveOnBIS(t) {
      return Object.values(t).every(
        (t) => t.configBIS && "ACTIVE" === t.configBIS.status
      );
    }
    isActiveOnCS(t) {
      return Object.values(t).every(
        (t) => t.configCS && "ACTIVE" === t.configCS.status
      );
    }
    isActiveOnIS(t) {
      return Object.values(t).some(
        (t) => t.configIS && "ACTIVE" === t.configIS.status
      );
    }
    async enableBadgeOnCollection(e) {
      if (0 === e.length) {
        console.log("No items detected.");
        return;
      }
      let i = {},
        s = window.ta.settings[this.shop.settings.templates.PO],
        a = window.ta.settings[this.shop.settings.templates.BIS],
        o = window.ta.settings[this.shop.settings.templates.CS],
        r = window.ta.settings[this.shop.settings.templates.IS];
      await Promise.all(
        Array.from(e).map(async (e) => {
          var n;
          if (t(e).data("product-id")) n = t(e).data("product-id");
          else {
            let l = t(e).find("a").attr("href");
            if (!l) return;
            let d = l.split("/").pop().split("?")[0];
            if (!d) return;
            console.log("Product handle: ", d);
            let c = await t.getJSON(window.location.origin + l);
            if (!c || !c.product || !c.product.id) return;
            n = String(c.product.id);
          }
          if (window.ta.products[n]) {
            let p = !1;
            window.ta.products[n].isPreorder &&
              s.badge.collection &&
              (this.addBadge(e, s.badge, "preorder"),
              (p = !0),
              s.button.collection &&
                s.button.collection.isEnabled &&
                this.enableButtonOnCollection(
                  e,
                  this.shop,
                  window.ta.products[n],
                  s
                )),
              window.ta.products[n].isBIS &&
                a.badge.collection &&
                (this.addBadge(e, a.badge, "bis"),
                (p = !0),
                this.enableButtonOnCollection(
                  e,
                  this.shop,
                  window.ta.products[n],
                  a
                )),
              window.ta.products[n].isCS &&
                o.badge.collection &&
                (this.addBadge(e, o.badge, "cs"),
                (p = !0),
                this.enableButtonOnCollection(
                  e,
                  this.shop,
                  window.ta.products[n],
                  o
                )),
              window.ta.products[n].isIS &&
                r.badge.collection &&
                (this.addBadge(e, r.badge, "is"), (p = !0)),
              p &&
                this.shop.selectors.hide &&
                this.shop.selectors.hide.collection &&
                t(e).find(this.shop.selectors.hide.collection).hide();
            return;
          }
          i[n] = e;
        })
      );
      let n = await new f().getProducts(Object.keys(i));
      if (!n) {
        console.log("[Error] Timesact API getProducts.");
        return;
      }
      for (let [l, d] of Object.entries(i)) {
        if (!(l in n.products)) {
          window.ta.products[l] = {
            isPreorder: !1,
            isBIS: !1,
            isCS: !1,
            isIS: !1,
            lastUpdate: parseInt(new Date().getTime() / 1e3),
          };
          continue;
        }
        let c = this.isActiveOnPreorder(n.products[l].variants),
          p = this.isActiveOnBIS(n.products[l].variants),
          u = this.isActiveOnCS(n.products[l].variants),
          m = this.isActiveOnIS(n.products[l].variants),
          h = !1;
        c &&
          s.badge.collection &&
          (this.addBadge(d, s.badge, "preorder"),
          (h = !0),
          s.button.collection &&
            s.button.collection.isEnabled &&
            this.enableButtonOnCollection(d, this.shop, n.products[l], s)),
          p &&
            a.badge.collection &&
            (this.addBadge(d, a.badge, "bis"),
            (h = !0),
            this.enableButtonOnCollection(
              d,
              this.shop,
              window.ta.products[l],
              a
            )),
          u &&
            o.badge.collection &&
            (this.addBadge(d, o.badge, "cs"),
            (h = !0),
            this.enableButtonOnCollection(
              d,
              this.shop,
              window.ta.products[l],
              o
            )),
          m &&
            r.badge.collection &&
            (this.addBadge(d, r.badge, "is"), (h = !0)),
          h &&
            this.shop.selectors.hide &&
            this.shop.selectors.hide.collection &&
            t(d).find(this.shop.selectors.hide.collection).hide(),
          (window.ta.products[l] = {
            isPreorder: c,
            isBIS: p,
            isCS: u,
            isIS: m,
            variants: n.products[l].variants,
            lastUpdate: parseInt(new Date().getTime() / 1e3),
          });
      }
      localStorage.setItem("products", JSON.stringify(window.ta.products));
    }
    getActiveConfigType(t) {
      return t.isBISEnabled
        ? "configBIS"
        : t.isCSEnabled
        ? "configCS"
        : t.isISEnabled
        ? "configIS"
        : "config";
    }
    enableButtonOnCollection(e, i, s, a) {
      let o = 'form[action="/cart/add"]';
      i.selectors.collection &&
        i.selectors.collection.form &&
        (o = i.selectors.collection.form);
      let r =
        '[type=submit]:visible:first, [data-pf-type="ProductATC"] span:first, [data-pf-type="ProductATC2"] span:first';
      i.selectors.collection &&
        i.selectors.collection.addToCartButton &&
        (r = i.selectors.collection.addToCartButton);
      let n = t(e).find(o);
      for (let l in s.variants) {
        let d = s.variants[l],
          c = this.getActiveConfigType(d),
          u = d[c];
        if (!u || u?.status !== "ACTIVE") continue;
        let m = t(e).find(r),
          b =
            window.ta.settings[u.settingsTemplate]?.button.name ||
            a.button.name;
        0 === t(m).length && (m = t(e).find('[type="submit"]')),
          t(m).val(b),
          t(m).text(b),
          t(m).prop("disabled", !1),
          t(e).find(".shopify-payment-button").hide(),
          "configBIS" === c &&
            ((window.ta.currentTimesactProductData = {
              defaultSettings: i.settings,
              productId: s?.id,
              productName: s?.title,
              productVariants: s.variants,
              variantId: l,
            }),
            t(m).click(p.displayBisModal)),
          "configCS" === c &&
            ((window.ta.currentTimesactProductData = {
              defaultSettings: i.settings,
              productId: s?.id,
              productName: s?.title,
              productVariants: s.variants,
              variantId: l,
            }),
            t(m).prop("disabled", !0));
        let g = new h(a.message.locale || "en-US");
        if (window.ta.settings[u.settingsTemplate]?.cart) {
          let f =
              window.ta.settings[u.settingsTemplate]?.cart.labelText.value ||
              a.cart?.labelText.value,
            v =
              window.ta.settings[u.settingsTemplate]?.cart.labelText.key ||
              a.cart?.labelText.key;
          (v = g.populateDynamicValues(d, v, !0, c)),
            (f = g.populateDynamicValues(d, f, !0, c)),
            0 === t(n).find("#preorder-label").length
              ? t(n).append(
                  '<input type="hidden" id="preorder-label" name="properties[' +
                    v +
                    ']" value="' +
                    f +
                    '" />'
                )
              : t(n).find("#preorder-label").val(f);
        }
      }
    }
    addBadge(e, i, s) {
      t(e).find('[data-pf-type="ProductMedia"], [data-pf-type="ProductMedia2"]')
        .length > 0 &&
        (e = t(e).find(
          '[data-pf-type="ProductMedia"], [data-pf-type="ProductMedia2"]'
        )),
        "absolute" !== t(e).css("position") &&
          t(e).css({ position: "relative" });
      let a = new r();
      a.add(e, i.type, i.value, s), a.applyStyles(i, s);
    }
  }
  t(document).ready(async function () {
    let e = new f(),
      i = new d();
    if (
      (p.createListeners(),
      i.initTimesact(),
      !i.isProductPage() &&
        !i.isCollectionPage() &&
        !i.isSearchPage() &&
        !i.isPagesPage() &&
        !i.isHomePage() &&
        !i.isCartPage())
    )
      return;
    let s = await e.getShop();
    if (
      !window.ta.settings ||
      (s.lastSettingsUpdate &&
        window.ta.lastSettingsUpdate < s.lastSettingsUpdate)
    ) {
      let { settings: a } = await e.getSettings();
      (window.ta.settings = a),
        (window.ta.lastSettingsUpdate =
          s.lastSettingsUpdate || parseInt(new Date().getTime() / 1e3)),
        localStorage.setItem("settings", JSON.stringify(window.ta.settings)),
        localStorage.setItem(
          "lastSettingsUpdate",
          JSON.stringify(window.ta.lastSettingsUpdate)
        );
    }
    if (i.isProductPage()) {
      let o = {};
      t.getJSON(window.location.href.split("?")[0].concat(".js"), function (t) {
        o = new l(t.id, t.variants, t.title, t.selling_plan_groups);
      })
        .done(function () {
          new y(s, o).run(!1);
        })
        .fail(function () {
          console.log("[Error 1001]: Product could not be fetched.");
        });
    }
    function r(e = 0, i = !1) {
      let a =
          JSON.parse(window.sessionStorage.getItem("closedModals") || null) ||
          [],
        o = s.settings.templates.PO;
      a.includes(o) ||
        setTimeout(() => {
          t.getJSON(window.location.origin + "/cart", function (t) {
            i && new y(s).runCartAlert(t), new y(s).runMixedCartAlert(t);
          }).fail(function () {
            console.log("[Error 1001]: Product could not be fetched.");
          });
        }, e);
    }
    (i.isCollectionPage() ||
      i.isHomePage() ||
      i.isSearchPage() ||
      i.isPagesPage()) &&
      (i.initQuickView(s), new y(s).runCollection());
    let n = t(s.selectors.form).find(s.selectors.addToCartButton);
    "button" !== n.prop("tagName") && (n = n.parent()),
      n.click(() => r(2e3)),
      t('a[href="/cart"]').click(() => r(500)),
      i.isCartPage() && r(0, !0);
  });
}),
  "undefined" == typeof jQuery || 100 > parseFloat(jQuery.fn.jquery)
    ? (function (t, e) {
        let i = document.createElement("script");
        (i.type = "text/javascript"),
          i.readyState
            ? (i.onreadystatechange = function () {
                ("loaded" === i.readyState || "complete" === i.readyState) &&
                  ((i.onreadystatechange = null), e());
              })
            : (i.onload = function () {
                e();
              }),
          (i.src = t),
          document.getElementsByTagName("head")[0].appendChild(i);
      })(
        "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js",
        function () {
          timesactScriptNew((jQuery191 = jQuery.noConflict(!0)));
        }
      )
    : timesactScriptNew(jQuery);
